module.exports = __webpack_public_path__ + "assets/img/news-card-ht.8063fe63.png";